import { Injectable } from '@angular/core';

import { Resolve } from '@angular/router';
import {Observable} from 'rxjs';
import {User} from '../User';
import {ApiService} from '../api/api.service';
import {CookieService} from 'ngx-cookie-service';

@Injectable()
export class LoginResolver implements Resolve<{ email, password }> {

  constructor(private api: ApiService, private cookieService: CookieService) {}

  resolve() {

    const email = this.cookieService.get('email');
    const password = this.cookieService.get('password');

    return {
      email : email,
      password: password
    }
  }


}
